var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUploadBig = function SvgUploadBig(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0DBD8B",
    fillRule: "evenodd",
    d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0m1.251 6.974a1.496 1.496 0 0 0-2.051-.129 2 2 0 0 0-.13.12l-6.274 6.589a1.5 1.5 0 1 0 2.173 2.069l3.688-3.873V23.06a1.5 1.5 0 1 0 3 0V11.75l3.688 3.873a1.5 1.5 0 1 0 2.173-2.07z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUploadBig);
export { ForwardRef as Icon };
export default "img/upload-big.ade34b1.svg";